"use strict";

/**
 * Updates the Order Summary subtotal, discount and savings lines shared by the basket and checkout
 * @param {Object} totals - The totals model from the AJAX response
 */
function updateOrderSummary(totals) {
    const orderSummary = totals && totals.orderSummary;

    if (!orderSummary) return;

    const hasDiscount = orderSummary.discount.value > 0;

    $(".order-summary-item-count").text(orderSummary.itemCountLabel);
    $(".order-summary-subtotal-label").text(orderSummary.subTotalLabel);
    $(".order-summary-subtotal").text(orderSummary.subTotal);
    $(".order-summary-delivery-label").text(orderSummary.deliveryLabel);
    $(".order-summary-discount").toggleClass("d-none", !hasDiscount);
    $(".order-summary-discount-total").text(orderSummary.discount.formatted);
    $(".order-summary-saving").toggleClass("d-none", !orderSummary.savingMessage).text(orderSummary.savingMessage);
}

module.exports = {
    updateOrderSummary
};
